import { z } from 'zod';
import { RoleSchema } from './common.js';

export const CreateUserSchema = z.object({
  email: z.string().email(),
  nome: z.string().min(1),
  papeis: z.array(RoleSchema).min(1),
});
export type CreateUserDTO = z.infer<typeof CreateUserSchema>;

export const UpdateUserSchema = z.object({
  nome: z.string().min(1).optional(),
  papeis: z.array(RoleSchema).min(1).optional(),
});
export type UpdateUserDTO = z.infer<typeof UpdateUserSchema>;

export const UserStatusSchema = z.enum(['ativo', 'inativo', 'convidado']);

export const UserViewSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  nome: z.string(),
  papeis: z.array(RoleSchema),
  status: UserStatusSchema,
});
export type UserViewDTO = z.infer<typeof UserViewSchema>;
